import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import AppLayout from '@/layouts/AppLayout';
import RouteErrorPage from '@/features/system/RouteErrorPage';
import { routeModuleLoaders } from './route-modules';

const DashboardPage = lazy(routeModuleLoaders.dashboard);
const InvoicesPage = lazy(routeModuleLoaders.invoices);
const IssueInvoicePage = lazy(routeModuleLoaders.issueInvoice);
const CustomersPage = lazy(routeModuleLoaders.customers);
const NumberingPage = lazy(routeModuleLoaders.numbering);
const ReportsPage = lazy(routeModuleLoaders.reports);
const ExportsPage = lazy(routeModuleLoaders.exports);
const ExceptionsPage = lazy(routeModuleLoaders.exceptions);
const AuditPage = lazy(routeModuleLoaders.audit);
const IamPage = lazy(routeModuleLoaders.iam);
const SettingsPage = lazy(routeModuleLoaders.settings);
const EnterprisesPage = lazy(routeModuleLoaders.enterprises);
const BrandsPage = lazy(routeModuleLoaders.brands);
const StoresPage = lazy(routeModuleLoaders.stores);
const NotFoundPage = lazy(routeModuleLoaders.notFound);

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteErrorPage />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'invoices', element: <InvoicesPage /> },
      { path: 'invoices/issue', element: <IssueInvoicePage /> },
      { path: 'customers', element: <CustomersPage /> },
      { path: 'numbering', element: <NumberingPage /> },
      { path: 'reports', element: <ReportsPage /> },
      { path: 'exports', element: <ExportsPage /> },
      { path: 'exceptions', element: <ExceptionsPage /> },
      { path: 'audit', element: <AuditPage /> },
      { path: 'iam', element: <IamPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'enterprises', element: <EnterprisesPage /> },
      { path: 'brands', element: <BrandsPage /> },
      { path: 'stores', element: <StoresPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
